//====================================================
//  Function: Select
//====================================================
function fn_components_select(){
	if ($( '.js-select' ).length){
		$( '.js-select' ).select2({
			minimumResultsForSearch: Infinity,
			placeholder: function(){
				$(this).data( 'placeholder' );
			}
		}).focus(function () { 
			$(this).select2( 'open' );
		});

		$('.js-select').on('select2:open', function (e) {
			$(this).closest( '.js-placeholder-block' ).addClass( class_active );
		});

		$('.js-select').on('select2:close', function (e) {
			if (!$( '.select2-selection__rendered' ).text().length){
				$(this).closest( '.js-placeholder-block' ).removeClass( class_active );
			}
		});
	}
}